import React from 'react'

export const EnergyIcon = (): JSX.Element => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 14 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group">
      <path
        id="Vector"
        d="M5.5277 20C5.41658 20 5.41658 20 5.30547 20C5.08325 19.8889 4.86103 19.6667 4.86103 19.3333V12.4444H0.972141C0.749919 12.4444 0.527696 12.3333 0.416585 12.1111C0.305474 11.8889 0.305474 11.6667 0.416585 11.4444L7.41659 0.333333C7.63881 0.111111 7.86103 0 8.19436 0C8.41658 0.111111 8.63881 0.333333 8.63881 0.666667V7.55556H12.5277C12.7499 7.55556 12.9721 7.66667 13.0833 7.88889C13.1944 8.11111 13.1944 8.33333 13.0833 8.55556L6.08325 19.6667C5.97214 19.8889 5.74992 20 5.5277 20ZM5.5277 11.2222C5.63881 11.2222 5.63881 11.2222 5.74992 11.2222C5.97214 11.3333 6.19436 11.5556 6.19436 11.8889V17.1111L11.4166 8.77778H8.08325C7.97214 8.77778 7.97214 8.77778 7.86103 8.77778C7.5277 8.66667 7.30547 8.44444 7.30547 8.11111V2.88889L2.08325 11.2222H5.5277Z"
        fill="black"
      />
    </g>
  </svg>
)
